import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import TableLoader from './components/TableLoader';
import EmptyTable from './components/EmptyTable';

import './CommonTable.scss';

const CommonTable = ({ children, content, rootClassName, renderBody, isLoading = false, maxHeight }) => {
  const tbodyRef = useRef(null);
  const [isHasScroll, setIsHasScroll] = useState(false);

  useEffect(() => {
    setIsHasScroll(tbodyRef.current && tbodyRef.current.scrollHeight > tbodyRef.current.clientHeight);
  }, [tbodyRef, content]);

  return (
    <div className={clsx('common-table', isHasScroll && 'common-table--scroll', rootClassName)}>
      <div className={'table'}>
        <div className={'thead'}>{children}</div>
        <div ref={tbodyRef} className={clsx('tbody')} style={{ maxHeight: !maxHeight ? '' : `${maxHeight}px` }}>
          {content.length ? content.map(renderBody) : <EmptyTable />}
        </div>
        {isLoading ? <TableLoader /> : null}
      </div>
    </div>
  );
};

export default CommonTable;
